import './note-view.scss';

import axios from 'axios';
import marked from 'marked';
import React, { useEffect, useState } from 'react';

import { ErrorView } from '../error-view/error-view';
import { Loading } from '../loading/loading';
import { NotFound } from '../not-found/not-found';
import { NoteViewContent } from '../note-view-content/note-view-content';
import { NOTE_VIEW_ERRORS } from './note-view.constants';

interface IProp {
  name: string;
}

export function NoteView({ name }: IProp) {
  const [markup, setMarkup] = useState('');
  const [loading, setLoading] = useState<{ state: boolean; info?: string }>({
    state: false,
  });
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const url = `/notes/${name}.md`;

    setLoading({ state: true, info: `fetching ${url}` });

    axios
      .get<string>(url)
      .then((markdown) => {
        setLoading({ state: true, info: 'parsing' });
        setError(null);

        setTimeout(() => {
          let markup = '';
          try {
            markup = marked(markdown.data);
          } catch (e) {
            setError(NOTE_VIEW_ERRORS.PARSE_ERROR);
          }
          setMarkup(markup);
          setLoading({ state: false });
        }, 0);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setError(NOTE_VIEW_ERRORS.NOT_FOUND);
        } else {
          setError(NOTE_VIEW_ERRORS.DEFAULT);
        }
        setLoading({ state: false });
      });
  }, [name]);

  let content;
  if (loading.state) {
    content = <Loading info={loading.info} />;
  } else if (error === NOTE_VIEW_ERRORS.NOT_FOUND) {
    content = <NotFound message={NOTE_VIEW_ERRORS.NOT_FOUND} />;
  } else if (error) {
    content = <ErrorView error={error} />;
  } else {
    content = <NoteViewContent html={markup} />;
  }

  return content;
}
